document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.mount-countdown .card').forEach(card => {
    card.style.cursor = 'pointer';
    card.addEventListener('click', (e) => {
      if (e.target.closest('a, button')) return;
      window.location.href = '/pages/aktion';   // ← THIS is where the link is set
    });
  });
});
/* Genusspunkte-CTAs -> LoyaltyLion.
   Buttons im Theme koennen nur ein href setzen, LoyaltyLion bietet aber keinen
   Link-Trigger fuer das Pop-up an. Deshalb werden Klicks auf #loyalty-lion
   (und die Smile.io-Altlast #smile-home) hier abgefangen und an den
   LoyaltyLion-Beacon ("Genusspunkte"-Button unten rechts) weitergereicht.
   Hinweis: Sollte in LoyaltyLion einmal das klassische Loyalty-Panel statt des
   Pop-ups aktiviert werden, ist das Attribut data-lion-account-link der
   offizielle Weg. */
(function () {
  var SELECTOR = 'a[href*="#loyalty-lion"], a[href*="#smile-home"]';

  function popupIsOpen() {
    var popup = document.getElementById('loyaltylion-popup-frame');
    return !!popup && popup.getBoundingClientRect().height > 0;
  }

  function openLoyalty() {
    if (popupIsOpen()) return true;

    var frame = document.getElementById('loyaltylion-beacon-frame');
    var doc = frame && frame.contentDocument;
    var beacon = doc && doc.querySelector('[data-testid="beacon"]');
    if (!beacon) return false;

    var target = beacon.querySelector('*') || beacon;
    var win = frame.contentWindow;
    var options = { bubbles: true, cancelable: true, composed: true, view: win };

    ['pointerdown', 'mousedown', 'pointerup', 'mouseup', 'click'].forEach(function (type) {
      var Ctor = type.indexOf('pointer') === 0 ? win.PointerEvent || win.MouseEvent : win.MouseEvent;
      target.dispatchEvent(new Ctor(type, options));
    });
    return true;
  }

  document.addEventListener('click', function (event) {
    if (!event.target.closest) return;
    var link = event.target.closest(SELECTOR);
    if (!link) return;

    // Kein toter #hash in der Adresszeile, egal ob das SDK schon geladen ist.
    event.preventDefault();
    if (openLoyalty()) return;

    // SDK laedt asynchron: bis zu ~6s auf den Beacon warten.
    var tries = 0;
    var timer = setInterval(function () {
      tries += 1;
      if (openLoyalty() || tries > 20) clearInterval(timer);
    }, 300);
  });
})();